import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
export const InfoRedirectPage = () => {
    const { guidePageType } = useParams();
    return _jsx(Navigate, { to: `/guide${guidePageType ? `/${guidePageType}` : ''}` });
};
